// Status chips. Identical treatment everywhere in the product — product rows,
// card headers, the topbar. One definition, no per-screen variants.

export type ChipKind = "pre-gate" | "passing" | "failing" | "killed" | "building";

const SPEC: Record<ChipKind, { label: string; color: string; bg: string; strike?: boolean }> = {
  "pre-gate": { label: "Pre-gate", color: "var(--text-3)", bg: "var(--muted-bg)" },
  passing: { label: "Passing", color: "var(--pos)", bg: "var(--pos-bg)" },
  failing: { label: "Failing", color: "var(--warn)", bg: "var(--warn-bg)" },
  killed: { label: "Killed", color: "var(--muted)", bg: "var(--muted-bg)", strike: true },
  building: { label: "Building", color: "var(--keeper)", bg: "var(--keeper-bg)" },
};

export function StatusChip({ kind, label }: { kind: ChipKind; label?: string }) {
  const s = SPEC[kind];
  return (
    <span className="chip" style={{ background: s.bg }}>
      <span className="chip-dot" style={{ background: s.color }} />
      <span
        className="chip-label"
        style={{ color: s.color, textDecoration: s.strike ? "line-through" : "none" }}
      >
        {label ?? s.label}
      </span>
    </span>
  );
}

/**
 * A product's chip is derived from its stage and its most recent gate verdict —
 * never from a hand-set status field, so it can't drift from the data.
 */
export function productChip(stage: string, gateResult: string | null): ChipKind {
  if (stage === "killed") return "killed";
  if (gateResult === "pass") return "passing";
  if (gateResult === "fail" || gateResult === "pivot") return "failing";
  if (stage === "validation") return "pre-gate";
  return "building";
}
